<template>
	<div class="hd-mod-frame-virus-entry">
		<base-image-svg
			class="js-mod-frame-virus-entry hd-mod-frame-virus-entry__svg"
			:source="require('!html-loader!../../assets/svgs/09-mod-frame-virus-entry.svg')"
		/>
		<base-image-svg
			class="js-mod-frame-virus-entry hd-mod-frame-virus-entry__svg--mobile"
			:source="require('!html-loader!../../assets/svgs/09-mod-frame-virus-entry-mobile.svg')"
		/>
	</div>
</template>

<style lang="scss" scoped>
	.hd-mod-frame-virus-entry {
		position: absolute;
		left: 0;
		bottom: 0;
		@include box(100%);

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		:deep() svg {
			position: absolute;
			left: 0;
			bottom: -100px;
			width: 100%;

			@include fade-out();

			#sars_cov_2 {
				@include fade-out();
				@include animation-float();
			}

			#sars_cov_2_wrapper {
				transform: translate(50%, -50%);
				transition: all 1.5s ease;
			}

			#responders-1,
			#responders-2 {
				@include fade-out();
				@include animation-float-mini();
			}

			#virus-entry-labels {
				@include fade-out();
			}
		}

		// Animations
		[data-state="animation-ready"] {
			:deep() svg {
				@include animation-frame-enter-downwards();

				#responders-1,
				#responders-2,
				#virus-entry-labels {
					opacity: 1;
					transition-delay: 0.5s;
				}

				#sars_cov_2 {
					opacity: 1;
					transition-delay: 0.75s;
				}
				#sars_cov_2_wrapper {
					transform: translate(0, 0);
					transition-delay: 1s;
				}
			}
		}

		[data-state="animation-leave"] {
			:deep() svg {
				@include animation-frame-zoom-out();
			}
		}

		// Responsive 
		@include res-screen-small {
			:deep() svg {
				bottom: -250px;
			}
		}

		@include res-screen-x-small {
			:deep() svg {
				bottom: -340px;
			}
		}

		@include res-screen-portrait {
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}

			:deep() svg {
				bottom: auto;
				top: -130px;
			}
		}
	}
</style>

